import { Navigate } from 'react-router-dom';

import lazyWithRetry from 'utils/lazyWithRetry';

import { APP_ROUTES } from './routePaths';
import { createRoutes } from './utils/createRoute';

const pages = {
  NotFound: lazyWithRetry(() => import('@shared/components/NotFound/NotFound')),
  NetworkError: lazyWithRetry(() => import('pages/NetworkErrorPage/NetworkErrorPage')),
  WorkspaceEmailInvitePage: lazyWithRetry(() => import('pages/WorkspaceEmailInvitePage/WorkspaceEmailInvitePage')),
};

export default createRoutes([
  {
    path: APP_ROUTES.workspace,
    component: pages.WorkspaceEmailInvitePage,
  },
  {
    path: APP_ROUTES.networkError,
    component: pages.NetworkError,
  },
  {
    path: APP_ROUTES.notFound,
    component: pages.NotFound,
  },
  {
    path: '/*',
    element: <Navigate replace to={APP_ROUTES.notFound} />,
  },
]);
